// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"3ca56173","230":"ca9d6b96","388":"1f4a2310","482":"a14280ce","488":"770ee42e","523":"6daa6a97","681":"5fc7788f","750":"12b849a3","827":"de963e70","856":"b4b21969","916":"7d1d9be6","932":"96c68b2e"}[chunkId] + ".chunk.js";
};